import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import LanguageSwitcher from "./LanguageSwitcher";

/** Shared shell for public legal pages (/terms, /privacy). */
export const LegalShell = ({ titleKey, versionKey, dateKey, children, testId }) => {
  const { t } = useTranslation();
  const version = t(versionKey);
  const date = t(dateKey);

  return (
    <div style={{ background: "#f5f7fb", minHeight: "100vh" }}>
      <div className="container py-4" style={{ maxWidth: 860 }} data-testid={testId}>
        <div className="mb-3 d-flex justify-content-between align-items-center flex-wrap gap-2">
          <Link to="/" className="text-decoration-none fw-bold" style={{ color: "#0b3d91" }}
                data-testid="legal-home-link">
            <i className="bi bi-arrow-left me-2"></i>Tabel.kz
          </Link>
          <div className="d-flex align-items-center gap-3 flex-wrap">
            <div className="small text-muted">
              <Link to="/terms" className="me-3">{t("legal.terms_link")}</Link>
              <Link to="/privacy">{t("legal.privacy_link")}</Link>
            </div>
            <LanguageSwitcher />
          </div>
        </div>
        <div className="card card-soft"><div className="card-body p-4 p-md-5">
          <h1 className="h3 fw-bold mb-1">{t(titleKey)}</h1>
          <div className="text-muted small mb-4">
            {t("legal.version_meta", { version, date })}
          </div>
          <div className="legal-text" style={{ lineHeight: 1.7 }}>{children}</div>
        </div></div>
        <div className="text-center text-muted small py-3">
          © {new Date().getFullYear()} Tabel.kz — {t("legal.copyright")}
        </div>
      </div>
    </div>
  );
};

const TRANS_COMPONENTS = {
  strong: <strong />,
  privacyLink: <Link to="/privacy" />,
  termsLink: <Link to="/terms" />,
};

/** Paragraph from i18n; supports <strong> and internal links via Trans. */
export const LegalP = ({ i18nKey }) => (
  <p>
    <Trans i18nKey={i18nKey} components={TRANS_COMPONENTS} />
  </p>
);

export const LegalH5 = ({ i18nKey }) => {
  const { t } = useTranslation();
  return <h5 className="fw-semibold mt-4">{t(i18nKey)}</h5>;
};

/** First section heading — less top margin */
export const LegalH5First = ({ i18nKey }) => {
  const { t } = useTranslation();
  return <h5 className="fw-semibold mt-2">{t(i18nKey)}</h5>;
};
